import React, { useState } from 'react'
import { Badge } from 'reactstrap'
import { Link } from "react-router-dom"
import { providerPrefix } from 'configs/routePrefix'

const CardItem = (props) => {
    const { index, item, id, Service, name, status, updateHandler, setShouldGetData } = props
    const [itemStatus, setItemStatus] = useState(status)

    return (
        <>
            <tr key={index}>
                <td className='font-size-14'>{id}</td>
                <td className='font-size-14' style={{fontWeight: 700 }}>
                    <Link to={`${providerPrefix}/Admin-developer/compound-list/${id}`} onClick={()=> localStorage.setItem('developer_id', id)}>
                        {name.en}
                    </Link>
                </td>
                <th className='font-size-14'>{item.compounds_num}</th>
                <th className='font-size-14'>{item.units_num}</th>
                <th className='font-size-14'>{item.areas?.map((area,areaIndex) => {
                    return (
                        <span key={areaIndex}>
                            <Badge className="bgBadge font-size-14 mt-0 m-1"  
                                style={{ background: "#50a5f1",marginTop:"0px !important" }}>
                                    {area?.name?.en}
                            </Badge>
                            {areaIndex === 3 && <br />}
                            {areaIndex === 7 && <br />}
                         </span>
                    )
                })}</th>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                readOnly={true}
                            />
                        </div>
                    </form>
                </td>
            </tr>
        </>

    )
}

export default CardItem